import { Link } from 'react-router-dom'
import clsx from 'clsx'
import { toAbsoluteUrl } from '../../../helpers'
import { ChevronLeft } from 'lucide-react'
import { useLayout } from '../../core'
import { MutableRefObject, useEffect, useRef } from 'react'
import { ToggleComponent } from '../../../assets/ts/components'

type PropsType = {
  sidebarRef: MutableRefObject<HTMLDivElement | null>
}

const SidebarLogo = (props: PropsType) => {
  const { config } = useLayout()
  const toggleRef = useRef<HTMLDivElement>(null)

  const appSidebarDefaultMinimizeDesktopEnabled =
    config?.app?.sidebar?.default?.minimize?.desktop?.enabled
  const appSidebarDefaultCollapseDesktopEnabled =
    config?.app?.sidebar?.default?.collapse?.desktop?.enabled
  const toggleType = appSidebarDefaultCollapseDesktopEnabled
    ? 'collapse'
    : appSidebarDefaultMinimizeDesktopEnabled
      ? 'minimize'
      : ''
  const toggleState = appSidebarDefaultMinimizeDesktopEnabled ? 'active' : ''
  const appSidebarDefaultMinimizeDefault = config.app?.sidebar?.default?.minimize?.desktop?.default

  useEffect(() => {
    setTimeout(() => {
      const toggleObj = ToggleComponent.getInstance(toggleRef.current!) as ToggleComponent | null

      if (toggleObj === null) {
        return
      }

      // Add a class to prevent sidebar hover effect after toggle click
      toggleObj.on('kt.toggle.change', function () {
        // Set animation state
        props.sidebarRef.current!.classList.add('animating')

        // Wait till animation finishes
        setTimeout(function () {
          // Remove animation state
          props.sidebarRef.current!.classList.remove('animating')
        }, 300)
      })
    }, 600)
  }, [toggleRef, props.sidebarRef])

  return (
    <div className='px-2 app-sidebar-logo' id='kt_app_sidebar_logo' style={{ transitionDelay: "0.2s" }}>
      <Link to='/dashboard'>
        {config.layoutType === 'dark-sidebar' ? (
          <>
            <img
              alt='Logo'
              src={toAbsoluteUrl('/splashLogo.png')}
              className='px-17 h-70px app-sidebar-logo-default'
              style={{ transitionDelay: "0.2s" }}
            />
          </>
        ) : (
          <>
            {/* <img
              alt='Logo'
              src={toAbsoluteUrl('/tabLogo.png')}
              className='h-50px app-sidebar-logo-default theme-light-show'
              style={{ transitionDelay: "0.2s" }}
            /> */}
            {/* <img
              alt='Logo'
              src={toAbsoluteUrl('/splashLogo.png')}
              className='px-17 h-70px app-sidebar-logo-default'
              style={{ transitionDelay: "0.2s" }}
            /> */}
          </>
        )}

        <img
          alt='Logo'
          src={toAbsoluteUrl('/tabLogo.png')}
          className='h-40px app-sidebar-logo-minimize'
          style={{ transitionDelay: "0.2s" }}
        />
      </Link>

      {(appSidebarDefaultMinimizeDesktopEnabled || appSidebarDefaultCollapseDesktopEnabled) && false && (
        <div
          ref={toggleRef}
          id='kt_app_sidebar_toggle'
          className={clsx(
            'top-50 position-absolute btn-shadow w-30px h-30px translate-middle app-sidebar-toggle btn btn-icon btn-sm btn-color-muted btn-active-color-primary start-100 rotate',
            { active: appSidebarDefaultMinimizeDefault }
          )}
          data-kt-toggle='true'
          data-kt-toggle-state={toggleState}
          data-kt-toggle-target='body'
          data-kt-toggle-name={`app-sidebar-${toggleType}`}
          style={{ transitionDelay: "0.2s" }}
        >
          <ChevronLeft size={20} className='rotate-180 ms-1' />
        </div>
      )}
    </div>
  )
}

export { SidebarLogo }
